module.exports = __webpack_public_path__ + "static/media/social_ig_blue.9f33c42e.svg";